module.exports = __webpack_public_path__ + "static/media/ivan.615e9864.svg";